import { Major, MAJOR_ATTRIBUTE_OPTIONS } from '@backrs_ui/common-ui';
import type { AcademicExperienceRowData } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { getMajorRigorText } from '@backrs_ui/grow-ui/src/pages/Majors/majors.utils';
import { AcademicExperienceRowCard } from '@backrs_ui/grow-ui/src/pages/Majors/molecules/AcademicExperienceRowCard';

import { Box, SxProps, Theme } from '@mui/material';

import { useAgentContext } from './AcademicExperienceSection.agentContext';

const STRINGS = appStrings.modules.majors.academicExperience;

type AcademicExperienceSectionProps = Readonly<{
  major: Major;
}>;

export function AcademicExperienceSection({ major }: AcademicExperienceSectionProps) {
  useAgentContext(major);

  const academicExperienceRows: AcademicExperienceRowData[] = [
    {
      title: STRINGS.demand,
      tooltipText: STRINGS.demandInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.demand,
      selectedValue: major.demand,
      attributeKey: 'demand',
    },
    {
      title: STRINGS.optionValue,
      tooltipText: STRINGS.optionValueInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.optionValueName,
      selectedValue: major.optionValueName,
      attributeKey: 'optionValueName',
    },
    {
      title: STRINGS.rigor,
      tooltipText: STRINGS.rigorInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.rigor,
      selectedValue: getMajorRigorText(major.rigor),
      attributeKey: 'rigor',
    },
    {
      title: STRINGS.specialization,
      tooltipText: STRINGS.specializationInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.specialization,
      selectedValue: major.specialization,
      attributeKey: 'specialization',
    },
    {
      title: STRINGS.competitiveness,
      tooltipText: STRINGS.competitivenessInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.competitiveness,
      selectedValue: major.competitiveness,
      attributeKey: 'competitiveness',
    },
    {
      title: STRINGS.workloadIntensity,
      tooltipText: STRINGS.workloadIntensityInfo,
      options: MAJOR_ATTRIBUTE_OPTIONS.workload,
      selectedValue: major.workload,
      attributeKey: 'workload',
    },
  ];

  return (
    <Box sx={contentContainerSx}>
      <AcademicExperienceRowCard rows={academicExperienceRows} majorName={major.name} />
    </Box>
  );
}

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  '@container (min-width: 600px)': {
    flexDirection: 'row',
  },
  gap: backrs.spacing['spacing-4xl'],
  alignItems: 'flex-start',
});
